'use client'

import KeywordChip from '@/components/KeywordChip'
import { Click_select, Fuzzy_search, Search_or_ask, Search_query, Sort_ascending, Update } from '@indxsearch/pixl'
import ConsoleFeature, { chipClass } from './ConsoleFeature'

export default function StatisticsSection() {
  return (
    <ConsoleFeature
      id="statistics"
      eyebrow="Searched, chosen, counted"
      title="Search statistics"
      lead="See what visitors search for, what they choose, and where they choose it. Counted by your own server, with nothing sent anywhere else."
      href="https://docs.indx.co/http/Statistics"
      chips={<>
        <KeywordChip icon={<Search_query/>} tone="ink" className={chipClass} style={{ right: '30%', top: '50%' }}>Top queries</KeywordChip>
        <KeywordChip icon={<Fuzzy_search/>} className={chipClass} style={{ left: '14%', top: '-18px' }}>Fuzzy finds</KeywordChip>
        <KeywordChip icon={<Click_select/>} tone="mid" className={chipClass} style={{ left: '34%', top: '20%' }}>Click-through</KeywordChip>
      </>}
      main={{ name: 'statistics', alt: "The console's Statistics page: searches, fuzzy finds, click-through and click position over 30 days, as a chart." }}
      second={{ name: 'statistics-queries', alt: 'The most searched queries, with click-through and average position.' }}
      features={[
        { icon: <Search_query/>, label: 'Top queries' },
        { icon: <Fuzzy_search/>, label: 'Fuzzy finds' },
        { icon: <Click_select/>, label: 'Click-through and position' },
        { icon: <Sort_ascending/>, label: 'Top documents' },
        { icon: <Search_or_ask/>, label: 'Search or ask offers' },
        { icon: <Update/>, label: 'Changes on the chart' },
      ]}
    />
  )
}
